// React Imports
import React, {useEffect} from 'react';
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports

// App Imports
import ContractGrid from "./ContractGrid";
import ContractDrilldownFrame from "../ContractDrilldown/ContractDrilldownFrame";
import ConfigurationsTabs from "./Tabs/ConfigurationsTabs";
import ResidualsTabs from "./Tabs/ResidualsTabs";
import ParticipationsTabs from "./Tabs/ParticipationsTabs";
import RoyaltiesTabs from "./Tabs/RoyaltiesTabs";
import {changeContract} from "./contractSlice";
import {changeContractDrilldown} from "../ContractDrilldown/contractDrilldownSlice";
import {changeContractSection} from "../ContractSection/contractSectionSlice";
import {changeContractDrilldownExpandCS} from "../ContractDrilldown/contractDrilldownSliceExpandCS";
import ContractCsListDrawer from "./ContractListDrawers/ContractCsListDrawer";
import ContractCsfListDrawer from "./ContractListDrawers/ContractCsfListDrawer";
import ContractCdpListDrawer from "./ContractListDrawers/ContractCdpListDrawer";
import ContractCdpvListDrawer from "./ContractListDrawers/ContractCdpvListDrawer";
import ContractCdpvfListDrawer from "./ContractListDrawers/ContractCdpvfListDrawer";
import ContractVocabularyListDrawer from "./ContractListDrawers/ContractVocabularyListDrawer";
import ContractMarketListDrawer from "./ContractListDrawers/ContractMarketListDrawer";
import {changeContractDetailList} from "./ContractListDrawers/contractDetailListSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import CdpvPivotDrawer from "../WorkQueue/Pivot/CdpvPivotDrawer";
import DashboardPivotDrawer from "../WorkDashboard/WorkDashboardPivot/DashboardPivotDrawer";
import ConnieContractHelper from "../Connie/ConnieContractHelper";

// main function
export default function ContractFrame(props) {

    const [contractView, setContractView] = useState("ContractGrid");
    const [contractId, setContractId] = useState([]);
    const [contractMcode, setContractMcode] = useState([]);
    const [contractName, setContractName] = useState([]);
    const [contractDescription, setContractDescription] = useState([]);
    const [contractGridVisible, setContractGridVisible] = useState(true);
    const [contractDrilldownVisible, setContractDrilldownVisible] = useState(false);
    const selectorContractId = useSelector((state) => state.contractSlc.value.id);

    const   selectorDashboardPivotState = useSelector((state) => state.workSlc.value.dashboardPivotState);

    const dispatchData = useDispatch();


    const handleCsList = (id, name) => {
        console.log("handleCSList triggered");
        // console.log(rowFull);
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: true,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    const handleCsfList = (id, name) => {
        console.log("handleCSFList triggered");
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: true,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    const handleCdpList = (id, name) => {
        console.log("handleCDPList triggered");
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: true,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    const handleCdpvList = (id, name) => {
        console.log("handleCDPVList triggered");
        // console.log(rowFull);
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: true,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }

    const handleCdpvfList = (id, name) => {
        console.log("handleCDPVFList triggered");
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: true,
            vocabularyListDrawerState: false,
            marketListDrawerState: false}));
        ;
    }
    const handleVocabularyList = (id, name) => {
        console.log("handleVocabularyList triggered");
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: true,
            marketListDrawerState: false}));
        ;
    }

    const handleMarketList = (id, name) => {
        console.log("handleMarketList triggered");
        dispatchData(changeContractDetailList({
            contractId: id,
            contractName: name,
            dataPointId: 'null',
            csListDrawerState: false,
            csfListDrawerState: false,
            cdpListDrawerState: false,
            cdpvListDrawerState: false,
            cdpvfListDrawerState: false,
            vocabularyListDrawerState: false,
            marketListDrawerState: true}));
    }



    // original message handler
   //  function MessageHandlerComponent() {
   //      const dispatchData = useDispatch();
   //
   //      const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
   //      //
   //      // useEffect(() => {
   //      //     // Signal to parent that this window is ready
   //      //     if (window.opener) {
   //      //         window.opener.postMessage({ type: 'REQUEST_DATA' }, FRONTEND_URL);
   //      //     }
   //      //
   //      //     const handleMessage = (event) => {
   //      //         if (event.origin !== `${FRONTEND_URL}`) {
   //      //             console.warn("Untrusted origin:", event.origin);
   //      //             return;
   //      //         }
   //      //
   //      //         if (event.data && event.data.type === 'UPDATE_DATA') {
   //      //             // ... your existing dispatches
   //      //         }
   //      //     };
   //      //
   //      //     window.addEventListener('message', handleMessage);
   //      //     return () => window.removeEventListener('message', handleMessage);
   //      // }, [dispatchData]);
   //
   //      useEffect(() => {
   //          // Define the message event listener
   //          const handleMessage = (event) => {
   //              console.log("Message received by ContractFrame:", event.data);
   //
   //              // Validate the message origin (uncomment in production)
   //              // if (event.origin !== 'http://localhost:3000') {
   //                  if (event.origin !== `${FRONTEND_URL}`) {
   //                      console.warn("FRONTEND_URL:", import.meta.env.VITE_FRONTEND_URL);
   //                  console.warn("Untrusted origin:", event.origin);
   //                  return;
   //              }
   //
   //              // Check for the specific message type and handle it
   //              if (event.data && event.data.type === 'UPDATE_DATA') {
   //                  console.log("update data triggered.");
   //                  dispatchData(changeContract({ id: event.data.payload.contractId}));
   //                  dispatchData(changeContractDrilldown({ id: event.data.payload.contractId,
   //                  name:  event.data.payload.contractName, description: event.data.payload.contractDescription }));
   //                  dispatchData(changeContractSection({ id: event.data.payload.contractSectionId,
   //                      name:  event.data.payload.contractSectionName,   nameShort:  event.data.payload.contractSectionName.substring(0,70)}));
   //                  dispatchData(changeContract({ contractDrilldownVisible: true }));
   //                  dispatchData(changeContractDrilldownExpandCS({ contractSectionId: event.data.payload.contractSectionId,
   //                      contractSectionName:  event.data.payload.contractSectionName, csExpand: true, cdpId: event.data.payload.contractDataPointId,
   //                      parent1Id: event.data.payload.parentSection1Id,
   //                      parent2Id: event.data.payload.parentSection2Id,
   //                      parent3Id: event.data.payload.parentSection3Id,
   //                      parent4Id: event.data.payload.parentSection4Id,
   //                      parent5Id: event.data.payload.parentSection5Id,
   //                      parent6Id: event.data.payload.parentSection6Id,
   //                      parent7Id: event.data.payload.parentSection7Id,
   //                      parent8Id: event.data.payload.parentSection8Id,
   //                      parent9Id: event.data.payload.parentSection9Id,
   //                      parent10Id: event.data.payload.parentSection10Id
   //                  }));
   //
   //                  // dispatchData(changeContractDrilldownCS({ csExpand: true }));
   //                  console.log("I just got a message:", event.data);
   //                  console.log("Here's the message contract id:", event.data.payload.contractId);
   //                  console.log("Here's the message contract name:", event.data.payload.contractName);
   //                  console.log("Here's the message contract description:", event.data.payload.contractDescription);
   //                  console.log("Here's the message contract section id:", event.data.payload.contractSectionId);
   //                  console.log("Here's the message contract section name:", event.data.payload.contractSectionName);
   //                  console.log("Here's the message cdp id:", event.data.payload.contractDataPointId);
   //
   //
   //                  console.log("slice contract id: ", selectorContractId );
   //              }
   //          };
   //
   //          // Add the event listener for 'message' events
   //          window.addEventListener('message', handleMessage);
   //
   //          // Clean up the event listener on component unmount
   //          return () => {
   //              window.removeEventListener('message', handleMessage);
   //          };
   //      }, [dispatchData]);
   //
   //      return null; // No UI for this component
   //  }

// new ChatGpt message handler
    function MessageHandlerComponent() {
        const dispatchData = useDispatch();

        // Runtime-correct origin of *this* window
        const trustedOrigin = window.location.origin;

        useEffect(() => {
            const handleMessage = (event) => {
                if (event.origin !== trustedOrigin) {
                    console.warn("Untrusted origin:", event.origin, "expected:", trustedOrigin);
                    return;
                }

                // if (event.data?.type === "UPDATE_DATA") {
                //     const p = event.data.payload;
                    if (event.data && event.data.type === "UPDATE_DATA") {
                        const p = event.data.payload;
                    console.log("drilldown triggered by messaging")
                    dispatchData(changeContract({ id: p.contractId }));
                    dispatchData(changeContractDrilldown({
                        id: p.contractId,
                        name: p.contractName,
                        description: p.contractDescription,
                    }));
                    dispatchData(changeContractSection({
                        id:   p.contractSectionId,
                        name: p.contractSectionName,
                        nameShort: p.contractSectionName.substring(0, 70),
                    }));
                    dispatchData(changeContract({ contractDrilldownVisible: true }));
                    dispatchData(changeContractDrilldownExpandCS({
                        contractSectionId:   p.contractSectionId,
                        contractSectionName: p.contractSectionName,
                        csExpand:            true,
                        cdpId:               p.contractDataPointId,
                        parent1Id:  p.parentSection1Id,
                        parent2Id:  p.parentSection2Id,
                        parent3Id:  p.parentSection3Id,
                        parent4Id:  p.parentSection4Id,
                        parent5Id:  p.parentSection5Id,
                        parent6Id:  p.parentSection6Id,
                        parent7Id:  p.parentSection7Id,
                        parent8Id:  p.parentSection8Id,
                        parent9Id:  p.parentSection9Id,
                        parent10Id: p.parentSection10Id,
                    }));

                    console.log("Handled UPDATE_DATA from opener:", p);
                }
            };

            window.addEventListener("message", handleMessage);
            return () => window.removeEventListener("message", handleMessage);
        }, [dispatchData]);

        return null;   // no UI
    }


    return (
        <div>
            <MessageHandlerComponent />

            {useSelector((state) => state.contractSlc.value.residualsTabsVisible)
            &&
            <ResidualsTabs            />}
            {useSelector((state) => state.contractSlc.value.participationsTabsVisible)
                &&
                <ParticipationsTabs            />}
            {useSelector((state) => state.contractSlc.value.royaltiesTabsVisible)
                &&
                <RoyaltiesTabs            />}


            {                useSelector((state) => state.contractSlc.value.contractConfigVisible)
                && <ConfigurationsTabs/>
            }
            {useSelector((state) => state.contractSlc.value.contractGridVisible) &&

                <ContractGrid
                    onCsList={handleCsList}
                    onCsfList={handleCsfList}
                    onCdpList={handleCdpList}
                    onCdpvList={handleCdpvList}
                    onCdpvfList={handleCdpvfList}
                    onVocabularyList={handleVocabularyList}
                    onMarketList={handleMarketList}
                />
            }

            {

                useSelector((state) => state.contractSlc.value.contractDrilldownVisible) &&
                <ContractDrilldownFrame

                    onCsList={handleCsList}
                    onCsfList={handleCsfList}
                    onCdpList={handleCdpList}
                    onCdpvList={handleCdpvList}
                    onCdpvfList={handleCdpvfList}
                    onVocabularyList={handleVocabularyList}
                    onMarketList={handleMarketList}
                    // *** these are my inbound props
                    // passContractGridVisible={setContractGridVisible}
                    // passContractDrilldownVisible={setContractDrilldownVisible}
                    // *** these are my outbound props
                    // contractIdq = {contractId}
                    // contractId = {contractId}
                    // contractName = {contractName}
                    // contractDescription = {contractDescription}
                />
            }

            {useSelector((state) => state.contractDetailListSlc.value.csListDrawerState) && <ContractCsListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.csfListDrawerState) && <ContractCsfListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.cdpListDrawerState) && <ContractCdpListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.cdpvListDrawerState) && <ContractCdpvListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.cdpvfListDrawerState) && <ContractCdpvfListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.vocabularyListDrawerState) && <ContractVocabularyListDrawer/>}
            {useSelector((state) => state.contractDetailListSlc.value.marketListDrawerState) && <ContractMarketListDrawer/>}
            {selectorDashboardPivotState  &&
            <DashboardPivotDrawer/>
        }
            <CrudSnackbar/>
            {/*<ConnieContractHelper/>*/}
        </div>
    )
}

